import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        subject: '',
        name: '',
        email: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.subject || formData.subject === 'This question is about...') {
            newErrors.subject = 'Please select a topic';
        }
        if (!formData.name.trim()) {
            newErrors.name = 'Please enter your name';
        }
        if (!formData.email.trim()) {
            newErrors.email = 'Please enter your email address';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        if (!formData.message.trim()) {
            newErrors.message = 'Please enter your message';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            // Placeholder for future backend integration
            console.log('Form submitted:', formData);
            setSubmitted(true);

            // Reset form after 3 seconds
            setTimeout(() => {
                setFormData({
                    subject: '',
                    name: '',
                    email: '',
                    message: ''
                });
                setSubmitted(false);
            }, 3000);
        }
    };

    return (
        <>
            {/* CONTACTS SECTION */}
            <section
                id="contacts-2"
                className="bg-snow wide-50 inner-page-hero contacts-section division"
            >
                <div className="container">
                    {/* SECTION TITLE */}
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-8">
                            <div className="section-title title-02 mb-80">
                                {/* Title */}
                                <h2 className="h2-xs">
                                    Have a question? Need help? Don't hesitate, drop us a line
                                </h2>
                                {/* Text */}
                                <p className="p-xl">
                                    Our support team is here to help you get the most out of Rush Studio.
                                    Whether you have questions about features, need technical assistance,
                                    or want to discuss your translation needs, we're ready to assist.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* CONTACT FORM */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-8">
                            <div className="form-holder">
                                <form
                                    name="contactform"
                                    className="row contact-form"
                                    onSubmit={handleSubmit}
                                >
                                    {/* Form Select */}
                                    <div className="col-md-12 input-subject">
                                        <p className="p-lg">This question is about: </p>
                                        <span>
                                            Choose a topic, so we know who to send your request to:{' '}
                                        </span>
                                        <select
                                            className={`form-select subject ${errors.subject ? 'is-invalid' : ''}`}
                                            aria-label="Question topic"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                        >
                                            <option value="">This question is about...</option>
                                            <option value="account">Account & Billing</option>
                                            <option value="translation">Translation Services</option>
                                            <option value="technical">Technical Support</option>
                                            <option value="integrations">App Integrations</option>
                                            <option value="features">Feature Requests</option>
                                            <option value="other">Other</option>
                                        </select>
                                        {errors.subject && (
                                            <div className="error-message text-danger mt-2">
                                                {errors.subject}
                                            </div>
                                        )}
                                    </div>
                                    {/* Contact Form Input */}
                                    <div className="col-md-12">
                                        <p className="p-lg">Your Name: </p>
                                        <span>Please enter your real name: </span>
                                        <input
                                            type="text"
                                            name="name"
                                            className={`form-control name ${errors.name ? 'is-invalid' : ''}`}
                                            placeholder="Your Name*"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        {errors.name && (
                                            <div className="error-message text-danger mt-2">
                                                {errors.name}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-12">
                                        <p className="p-lg">Your Email Address: </p>
                                        <span>
                                            Please carefully check your email address for accuracy
                                        </span>
                                        <input
                                            type="email"
                                            name="email"
                                            className={`form-control email ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Email Address*"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <div className="error-message text-danger mt-2">
                                                {errors.email}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-12">
                                        <p className="p-lg">Explain your question in detail: </p>
                                        <span>
                                            Please provide as much detail as possible to help us
                                            assist you better.
                                        </span>
                                        <textarea
                                            className={`form-control message ${errors.message ? 'is-invalid' : ''}`}
                                            name="message"
                                            rows={6}
                                            placeholder="I have a question about..."
                                            value={formData.message}
                                            onChange={handleChange}
                                        />
                                        {errors.message && (
                                            <div className="error-message text-danger mt-2">
                                                {errors.message}
                                            </div>
                                        )}
                                    </div>
                                    {/* Contact Form Button */}
                                    <div className="col-md-12 mt-15 form-btn text-right">
                                        <button
                                            type="submit"
                                            className="btn btn-skyblue tra-grey-hover submit"
                                        >
                                            Submit Request
                                        </button>
                                    </div>
                                    {/* Contact Form Message */}
                                    <div className="col-lg-12 contact-form-msg">
                                        {submitted && (
                                            <div className="alert alert-success mt-3" role="alert">
                                                Thank you for your message! We'll get back to you soon.
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {/* END CONTACT FORM */}
                </div>
                {/* End container */}
            </section>
            {/* END CONTACTS-2 */}

            {/* DIVIDER LINE */}
            <hr className="divider" />

            {/* CALL TO ACTION-8 */}
            <section id="cta-8" className="bg-snow wide-100 cta-section division">
                <div className="container">
                    <div className="cta-8-wrapper pc-25">
                        <div className="row row-cols-1 row-cols-md-2">
                            {/* BOX #1 */}
                            <div className="col">
                                <Link to="/#pricing">
                                    <div className="cta-box cta-top-box bg-white wow fadeInUp">
                                        {/* Icon */}
                                        <div className="cta-ico">
                                            <div className="ico-60">
                                                <span className="flaticon-wallet" />
                                            </div>
                                        </div>
                                        {/* Text */}
                                        <div className="cta-txt">
                                            {/* Title */}
                                            <h5 className="h5-md">View Pricing</h5>
                                            {/* Text */}
                                            <p className="p-lg">
                                                Explore our flexible pricing plans designed to fit
                                                teams of all sizes and budgets.
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* END BOX #1 */}
                            {/* BOX #2 */}
                            <div className="col">
                                <Link to="/faqs">
                                    <div className="cta-box bg-white wow fadeInUp">
                                        {/* Icon */}
                                        <div className="cta-ico">
                                            <div className="ico-60">
                                                <span className="flaticon-help" />
                                            </div>
                                        </div>
                                        {/* Text */}
                                        <div className="cta-txt">
                                            {/* Title */}
                                            <h5 className="h5-md">Read the FAQs</h5>
                                            {/* Text */}
                                            <p className="p-lg">
                                                Find quick answers to common questions about Rush Studio
                                                and our translation services.
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* END BOX #2 */}
                        </div>
                        {/* End cta-8-wrapper */}
                    </div>
                    {/* End row */}
                </div>
                {/* End container */}
            </section>
            {/* END CALL TO ACTION-8 */}

            {/* DIVIDER LINE */}
            <hr className="divider" />
        </>
    );
};

export default ContactPage;
